import { Avatar, Card, Center, Group, Image, Text } from '@mantine/core';
import classes from './YoutubeCard.module.css';
import { Wrapper } from './YoutubeCard.style';

export type IClip = {
  id: string;
  thumbnail: string;
  title: string;
  url: string;
};

export type YoutubeCardProps = {
  clip: IClip;
  onClick: () => void;
};

export function YoutubeCard(props: YoutubeCardProps) {
  const { clip } = props;
  const { title, thumbnail } = clip;

  return (
    <Wrapper className='YoutubeCard-wrapper' data-testid='YoutubeCard-wrapper'>
      <Card withBorder radius='md' className={classes.card}>
        <Card.Section className={classes.top}>
          <a onClick={props.onClick}>
            <Image src={thumbnail} height={120} />
          </a>
        </Card.Section>
        <Text className={classes.title} fw={800} component='a'>
          {title}
        </Text>

        <Text fz='sm' c='dimmed' lineClamp={4}></Text>

        <Group justify='space-between' className={classes.footer}>
          <Center>
            <Avatar src='/avatar-sloyd.jpg' size={24} radius='xl' mr='xs' />
            <Text fz='sm' inline>
              Sloyd
            </Text>
          </Center>
        </Group>
      </Card>
    </Wrapper>
  );
}

export default YoutubeCard;
